import React, {useCallback, useEffect} from 'react'
import View from './view'
import {useSelector} from 'react-redux'
import {
  Attempt,
  getReportedExamResults,
  selectNcarbAttempts,
} from '../../../../redux/reportExamStatus'
import {useAuth} from '../../../../components/AuthProvider'
import {useAppDispatch} from '../../../../redux/configureStore'

type Props = {
  courseId?: string
  division: string
}

const CurrentStatusCard = ({courseId, division}: Props) => {
  const auth = useAuth()
  const dispatch = useAppDispatch()

  const examReports = useSelector(selectNcarbAttempts)

  const loadReports = useCallback(async () => {
    await dispatch(getReportedExamResults({auth}))
  }, [dispatch, auth.isAuthenticated])

  useEffect(() => {
    if (auth.isAuthenticated) {
      loadReports()
    }
  }, [loadReports])

  const uniqueReports: Attempt[] = Object.values(
    (examReports ?? [])
      .filter(report => report.courseId)
      .reduce<Record<string, Attempt>>((acc, report) => {
        if (
          !acc[report.courseId] ||
          new Date(report.updatedAt) > new Date(acc[report.courseId].updatedAt)
        ) {
          acc[report.courseId] = report
        }
        return acc
      }, {}),
  )

  const report = uniqueReports.find(r => r.courseId === courseId)

  return <View report={report} division={division} />
}

export default CurrentStatusCard
